import {
  checkEvaluation as checkEvaluationApi,
  create as createApi,
  initMenu as initMenuApi,
  sampleExcelDownload as sampleExcelDownloadApi,
  search as searchApi,
  stop as stopApi,
  update as updateApi,
  uploadFile as uploadFileApi
} from "../../service/StudentService";

export const CREATE_SUCCESS = "STUDENT_CREATE_SUCCESS";
export const CREATE_FAIL = "STUDENT_CREATE_SUCCESS";
export const UPLOAD_FILE_SUCCESS = "STUDENT_UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "STUDENT_UPLOAD_FILE_FAIL";
export const SEARCH_SUCCESS = "STUDENT_SEARCH_SUCCESS";
export const SEARCH_FAIL = "STUDENT_SEARCH_FAIL";
export const UPDATE_SUCCESS = "STUDENT_UPDATE_SUCCESS";
export const UPDATE_FAIL = "STUDENT_UPDATE_FAIL";
export const ACCOUNT_STOP_SUCCESS = "STUDENT_ACCOUNT_STOP_SUCCESS";
export const ACCOUNT_STOP_FAIL = "STUDENT_ACCOUNT_STOP_SUCCESS";
export const STUDENT_MENU_INIT_SUCCESS = "STUDENT_MENU_INIT_SUCCESS";
export const STUDENT_MENU_INIT_FAIL = "STUDENT_MENU_INIT_FAIL";
export const SELFEVALUATION_CHECK_OK = "SELFEVALUATION_CHECK_OK";
export const SELFEVALUATION_CHECK_NG = "SELFEVALUATION_CHECK_NG";
export const SELFEVALUATION_CHECK_FAIL = "SELFEVALUATION_CHECK_FAIL";
export const EXCEL_DOWNLOAD = "STUDENT_EXCEL_DOWNLOAD";

export const create = rows => dispatch => {
  const params = [];
  const errorMessages = [];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    // 通し番号が空のカラムはデータ無しとして判断する。
    if (row.serialNumber === "") {
      continue;
    }

    if (!row.email) {
      errorMessages.push(`${i + 1}行目のメールアドレスが入力されていません。`);
    }
    if (!row.password) {
      errorMessages.push(`${i + 1}行目のパスワードが入力されていません。`);
    } else {
      params.push(row);
    }
  }

  if (errorMessages.length > 0) {
    alert(errorMessages.join("\r\n"));
    return;
  }

  createApi(params)
    .then(response => {
      dispatch({
        type: CREATE_SUCCESS,
        payload: {
          message: response.message
        }
      });
      if (response.messageCode) {
        alert(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);
        return;
      } else {
        alert(response.message);
        return;
      }
    })
    .catch(error => {
      dispatch({
        type: CREATE_FAIL,
        payload: {
          message: error
        }
      });
      console.error("登録エラー:", error);
      alert("生徒情報の登録中にエラーが発生しました。");
    });
};

export const uploadFile = params => dispatch => {
  uploadFileApi(params)
    .then(response => {
      dispatch({
        type: UPLOAD_FILE_SUCCESS,
        payload: {
          messageCode: response.messageCode,
          message: response.message
        }
      });
      alert(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);
    })
    .catch(error => {
      dispatch({
        type: UPLOAD_FILE_FAIL,
        payload: {
          error: error
        }
      });
      console.error("ファイルのアップロードエラー:", error);
      alert("ファイルのアップロード中にエラーが発生しました。");
    });
};

export const search = request => dispatch => {
  searchApi(request)
    .then(response => {
      const rows = response.students.map((student, index) => {
        return {
          id: index,
          serialNumber: student.serialNumber,
          grade: student.grade,
          classNumber: student.classNumber,
          number: student.number,
          name: student.name,
          password: student.password,
          email: student.email,
          endDate: student.endDate
        };
      });
      dispatch({
        type: SEARCH_SUCCESS,
        payload: {
          rows: rows
        }
      });
    })
    .catch(error => {
      dispatch({
        type: SEARCH_FAIL,
        payload: {
          error: error
        }
      });
    });
};
export const update = request => dispatch => {
  updateApi(request)
    .then(response => {
      if (response.message) {
        dispatch({ type: UPDATE_FAIL, payload: { message: response.message } });
        alert(response.message);
        return;
      }
      dispatch({ type: UPDATE_SUCCESS });
      alert("選択した生徒を更新しました。");
    })
    .catch(error => {
      dispatch({
        type: UPDATE_FAIL,
        payload: { error: error }
      });
    });
};

export const stop = request => dispatch => {
  stopApi(request)
    .then(() => {
      dispatch({ type: ACCOUNT_STOP_SUCCESS });
      alert("選択した生徒のアカウントを停止しました。");
    })
    .catch(error => {
      dispatch({
        type: ACCOUNT_STOP_FAIL,
        payload: {
          error: error
        }
      });
    });
};

export const initMenu = () => dispatch => {
  initMenuApi()
    .then(response => {
      if (response.message) {
        dispatch({
          type: STUDENT_MENU_INIT_FAIL,
          payload: {
            messageCode: response.messageCode,
            message: response.message
          }
        });
        alert(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);
        return;
      }

      dispatch({
        type: STUDENT_MENU_INIT_SUCCESS,
        payload: {
          list: response.evaluationList,
          term: response.evaluationTerm,
          student: response.student
        }
      });
    })
    .catch(error => {
      dispatch({
        type: STUDENT_MENU_INIT_FAIL,
        payload: {
          error: error
        }
      });
    });
};

export const checkEvaluation = param => dispatch => {
  if (!param.listId) {
    alert("評価の項目を選択してください。");
    return;
  }

  const request = {
    listId: param.listId,
    termId: param.termId
  };
  checkEvaluationApi(request)
    .then(response => {
      if (response.message) {
        dispatch({ type: SELFEVALUATION_CHECK_NG, payload: { message: response.message, code: response.messageCode } });
        var result = window.confirm(`メッセージコード:${response.messageCode}\r\nメッセージ:${response.message}`);

        if (result) {
          window.location.href = `/WebEvaluation1?serialNumber=${param.student.serialNumber}&grade=${param.student
            .grade}&classNumber=${param.student.classNumber}&number=${param.student.number}&name=${param.student
            .name}&listId=${param.listId}&termId=${param.termId}`;
        }
        return;
      }
      dispatch({ type: SELFEVALUATION_CHECK_OK });
      window.location.href = `/WebEvaluation1?serialNumber=${param.student.serialNumber}&grade=${param.student
        .grade}&classNumber=${param.student.classNumber}&number=${param.student.number}&name=${param.student
        .name}&listId=${param.listId}&termId=${param.termId}`;
    })
    .catch(error => {
      dispatch({ type: SELFEVALUATION_CHECK_FAIL, payload: { error: error } });
    });
};

export const excelDownload = () => dispatch => {
  sampleExcelDownloadApi().then(response => {
    dispatch({ type: EXCEL_DOWNLOAD, payload: { url: response.data } });

    // サーバーサイドのエンドポイントからデータのURLを取得
    const fileURL = response;

    // ダウンロード用リンクを作成
    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL; // データのURLを設定
    downloadLink.target = "_blank";
    downloadLink.download = "student_upload_sample.xlsx"; // ダウンロード時のファイル名を指定

    // リンクをクリックしてダウンロードを開始します
    downloadLink.click();
  });
};
